export const INPUT_EMPTY_TEXT = 'Не заполнено';
export const INPUT_TEL_TYPE = 'tel';
